#import "../../list/DataAccessPolicyFields.graphql"

mutation DataAccessPolicyUpdate($input: DataAccessPolicyUpdateInput!) {
  dataAccessPolicyUpdate(input: $input) {
    dataAccessPolicyUpdateType {
      _isCompanyTokenRefreshRequired
      dataAccessPolicy {
        ...DataAccessPolicyFields
      }
    }
  }
}